import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { keys } from '@/api/queryKeys';
import { useServiceToken } from '@/auth/index';
import { AppRequests } from '@/context/AppRequests';

export const useApiDataPoints = () => {
  const { fetchApiDataPoints } = useContext(AppRequests).ApiKeysRequests;
  const { data: tokenData } = useServiceToken('lizano');

  const results = useQuery({
    queryKey: [keys.API_DATA_POINTS],
    queryFn: () => fetchApiDataPoints(tokenData?.token),
    enabled: Boolean(tokenData?.token),
  });

  return { ...results };
};
